import React, { useEffect, useRef, useState } from 'react'
import Image from 'next/image'
import { RequestProvider } from '../../../../context/RequestContext'
import { s3Static } from '../../../../utils/constants'
import { Services } from '../../service/Services'
import { openModal } from '../../../../service/modal-service'
import { AnimatePresence, motion, useMotionValueEvent, useScroll } from 'framer-motion'
import { PartTimeHelperBooking } from './PartTimeHelperBooking'
import { HelperServiceScope } from './HelperServiceScope'

export const PartTimeHelperRequestFormSlug = (props) => {
    const requestCategorySettings = props.requestCategorySettings
    const helperService = props.helperService
    const elderlyCareService = props.elderlyCareService
    const countryName = props.countryName
    const currencyCd = props.currencyCd
    const post = props.post
    const requestType = "Domestic Services"
    
    const [ requestForm, setRequestForm ] = useState(false)
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    const [ isShowJobScope, setIsShowJobScope ] = useState(false)
    const [ isShowBottomButtons, setIsShowBottomButtons ] = useState(false)

    const openRequestForm = () => {
        window.scrollTo({ top: 0 });
        // setRequestForm(true)
        openModal(setRequestForm)
    }

    const videoRef = useRef();

    useEffect(() => {  
        videoRef.current.play()
    }, [])

    const { scrollY } = useScroll()

    useMotionValueEvent(scrollY, "change", (latest) => {
        if(latest > 100){
            if(!isShowBottomButtons){
                setIsShowBottomButtons(true)
            }
        } else {
            if(isShowBottomButtons){
                setIsShowBottomButtons(false)
            }
        }
    })

  return (
    <>
        <section id="part-time-cleaner-singapore" className='relative'>
            <div className="-mt-14 relative w-full aspect-video sm:h-180 overflow-hidden">    
                {/* Video (mobile only) */}
                <video
                    ref={videoRef}
                    className="absolute inset-0 w-full h-full object-cover sm:hidden"
                    poster={s3Static + "blog/living/part-time-helper/part-time-cleaners-singapore-1920-1080.jpg"}
                    muted
                    loop
                    playsInline
                >
                    <source src="/video/part-time-helper-web.mp4"/>
                    <source src="/video/part-time-helper-web.mov"/>
                </video>

                {/* Image (desktop only) */}
                <Image
                    src={s3Static + "part-time-helper/part-time-helper-in-gray-uniform-living.jpg"}
                    fill
                    className="hidden sm:block object-cover"
                    alt="Part-time helper Singapore"
                    priority
                    sizes="100vw"
                />
            </div>
            <RequestProvider>
                <div id="campaign" className='relative bg-gray-100 sm:bg-transparent sm:text-white w-full py-2 sm:absolute sm:top-1/2 sm:-translate-y-1/2'>
                    <PartTimeHelperBooking requestCategorySettings={requestCategorySettings} helperService={helperService} elderlyCareService={elderlyCareService} 
                    setRequestForm={setRequestForm} setIsQuickBook={setIsQuickBook} countryName={countryName} currencyCd={currencyCd} helperType="Helper" setIsShowJobScope={setIsShowJobScope}/>
                </div>
                {requestForm &&
                    <Services requestType={requestType} requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm} isQuickBook={isQuickBook} asSheet/>
                }      
                <motion.div className='fixed bottom-2 w-full text-center z-10 flex justify-center space-x-5'
                    initial={{y: "50px"}}
                    animate={isShowBottomButtons ? {y: "0px"} : {y: "50px"}}
                    transition={{type: "spring", stiffness: 100, ease: "easeInOut", duration: 0.3}}
                    >
                    <button type="button" className='text-white py-2 px-8 rounded-full bg-linear-to-tr from-orange-600 to-amber-400 block font-bold ' onClick={() => openRequestForm()}>
                        Book
                    </button>
                </motion.div>
            </RequestProvider> 
        </section>        
        {isShowJobScope &&
            <AnimatePresence>
                <HelperServiceScope/>
            </AnimatePresence>
        } 
    </>
  )
}